import { render } from "./termPage.vue?vue&type=template&id=08bf1eba&scoped=true"
import script from "./termPage.vue?vue&type=script&lang=js"
export * from "./termPage.vue?vue&type=script&lang=js"

import "./termPage.vue?vue&type=style&index=0&id=08bf1eba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bf1eba"]])

export default __exports__